<script lang="ts">
  /**
   * Icon - renders a line icon from lib/icons.ts.
   *
   * Color comes from CSS: the icon uses the surrounding text color, or
   * `--icon-color` when set. Each <svg> also gets an `icon-<name>` class so a
   * single icon can be targeted from a parent's styles with :global().
   *
   * Decorative by default (hidden from assistive tech). Pass `label` when the
   * icon is the only content of a control and needs an accessible name.
   */
  import { ICONS, type IconName } from '../lib/icons';

  interface Props {
    name: IconName;
    /** Width and height in px (or any CSS length). */
    size?: number | string;
    strokeWidth?: number;
    label?: string;
    class?: string;
  }

  let { name, size = 14, strokeWidth = 1.5, label, class: className = '' }: Props = $props();
</script>

<svg
  class="icon icon-{name} {className}"
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  stroke="currentColor"
  stroke-width={strokeWidth}
  stroke-linecap="round"
  stroke-linejoin="round"
  focusable="false"
  role={label ? 'img' : undefined}
  aria-label={label}
  aria-hidden={label ? undefined : 'true'}
>
  {#each ICONS[name] as shape, i (i)}
    <path
      d={shape.d}
      fill={shape.fill ? 'currentColor' : undefined}
      stroke={shape.fill ? 'none' : undefined}
    />
  {/each}
</svg>

<style>
  .icon {
    display: inline-block;
    flex-shrink: 0;
    color: var(--icon-color, currentColor);
  }
</style>
